type Props = {
  onRetry: () => void;
  retrying: boolean;
};

/**
 * Shown over data kept from before a failed refresh (reviews D4-06, RT-07
 * keep it on screen; D7-01): without it the calendar or a shift looked current
 * while it was not, with no way to try again before the next 30-second poll.
 */
const RefreshFailedNote = ({ onRetry, retrying }: Props) => (
  <div
    className="dashv2-refreshfailed"
    role="status"
    data-testid="refreshFailed"
  >
    <span>Couldn&apos;t refresh</span>
    <span aria-hidden="true">·</span>
    <button type="button" onClick={onRetry} disabled={retrying}>
      {retrying ? 'Retrying…' : 'Retry'}
    </button>
  </div>
);

export default RefreshFailedNote;
